<script setup>
// SiteUp: no celular (abaixo de 768px) o dock do Modo Foco não monta, e a
// barra inferior só tem Hub, Conversas, Contatos e Kanban. Menu de perfil
// (status de disponibilidade, tema, sair), sino de notificações e sino de
// tarefas só existiam no dock: quem atende pelo celular ou pelo PWA não
// conseguia ficar offline nem sair do app. Os mesmos três componentes do dock
// ficam aqui, no topo do Hub, só no celular.
import { useI18n } from 'vue-i18n';
import SidebarTasksBell from 'dashboard/components-next/sidebar/SidebarTasksBell.vue';
import SidebarNotificationBell from 'dashboard/components-next/sidebar/SidebarNotificationBell.vue';
import SidebarProfileMenu from 'dashboard/components-next/sidebar/SidebarProfileMenu.vue';

const { t } = useI18n();
</script>

<template>
  <div
    class="flex shrink-0 items-center gap-1"
    role="group"
    :aria-label="t('HUB.PERSONAL_BAR')"
    data-testid="hub-personal-bar"
  >
    <SidebarTasksBell variant="icon" />
    <SidebarNotificationBell variant="icon" />
    <SidebarProfileMenu is-collapsed />
  </div>
</template>
